import { Avatar, Box, Paper } from "@mui/material";
import OverFlowText from "../../components/OverFlowText";
import { useState } from "react";
import { useEffect } from "react";
import {
  downloadImageUrl,
  getPersonByIdOrCode,
} from "../../services/PersonService";
import { useLocation } from "react-router-dom";
import RightViewLayout from "../../components/RighViewLayout";
import { REACT_USER } from "../../router/ReactEndPoints";
import { useTranslation } from "react-i18next";

export default function ViewUser() {
  const { t } = useTranslation();
  const location = useLocation();
  const [person, setPerson] = useState({});
  const [objectKey, setObjectKey] = useState();
  const [user, setUser] = useState();
  const [clientId, setClientId] = useState("");
  const [image, setImage] = useState(null);

  useEffect(() => {
    setUser(JSON.parse(localStorage?.getItem("USER")));
  }, []);

  useEffect(() => {
    setClientId(user?.id);
  }, [user]);

  useEffect(() => {
    getPersonByIdOrCode(location?.state?.id, user?.id).then((res) => {
      if (res?.data?.data && res?.data?.code === "LVLI0000") {
        setPerson(res.data.data);
        setObjectKey(res?.data?.data?.imageObjectKey);
      }
    });
  }, [clientId]);

  useEffect(() => {
    if (objectKey) {
      downloadImageUrl(objectKey).then((res) => {
        if (res?.data?.data && res?.data?.code === "LVLI0000")
          setImage(res.data.data.preSignedUrl);
      });
    }
  }, [objectKey]);

  return (
    <RightViewLayout
      id="viewpersonback"
      title={t("user.view_person")}
      navigateBack={REACT_USER}
    >
      <Paper
        elevation={0}
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          paddingTop: "20px",
          paddingBottom: "36px",
          paddingLeft: "26px",
          border: "1px solid #DDDDDD",
          margin: "0 1rem 2rem 0",
          overflow: "hidden",
        }}
      >
        <Box>
          <Box>
            <Avatar
              imgProps={{ draggable: "false" }}
              alt="Organisation profile pic"
              src={image}
              sx={{ width: 150, height: 150 }}
            />
          </Box>
          <Box pt={2}>
            <Box>
              <OverFlowText variant="fieldLabel">
                {t("table.first_name")}:
              </OverFlowText>
            </Box>
            <OverFlowText variant="fieldValue">
              {person && person.firstName ? person.firstName : "-"}
            </OverFlowText>

            <Box mt={2}>
              <OverFlowText variant="fieldLabel">
                {t("table.last_name")}:
              </OverFlowText>
            </Box>
            <OverFlowText variant="fieldValue">
              {person && person.lastName ? person.lastName : "-"}
            </OverFlowText>

            <Box mt={2}>
              <OverFlowText variant="fieldLabel">
                {t("table.email")}:
              </OverFlowText>
            </Box>
            <OverFlowText variant="fieldValue">
              {person && person.email ? person.email : "-"}
            </OverFlowText>
          </Box>
        </Box>
      </Paper>
    </RightViewLayout>
  );
}
